import React, { useState, useEffect } from 'react';
import axios from '../../api/api';
import { toast } from 'react-toastify';

const Setting = () => {

  // current user details
  const user = window.localStorage.getItem('token');
  const currentUser = JSON.parse(user).data._id;

  const [firstName, setFirstName] = useState([]);
  const [lastName, setLastName] = useState([]);
  const [password, setPassword] = useState([]);

  useEffect(() => {  
    const getUser = async () => {
      const response = await axios.get(`/api/v2/users/${currentUser}`);
      setFirstName(response.data.firstName);
      setLastName(response.data.lastName);
      setPassword(response.data.password);
    };
    getUser();
  }, [currentUser]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`/api/v2/users/update/${currentUser}`, {
        firstName,
        lastName,
        password
      });
      toast.success('Profile Updated')
    } catch (error) {
      toast.error('Failed To Updated')
      console.error('Error updating user:', error);
    }
  };

  
  return (
    <main>
      <div className='mx-auto p-4 lg:container'>
        <h3>Account Settings</h3>
        <div className='bg-white p-6 rounded-lg mt-4'>
          <div>
            <h4><u>Edit Account Details</u></h4>
            <form onSubmit={handleSubmit}>
              <div className='p-1'>
                <label htmlFor='username'>Firstname : <br />
                  <input
                    type='text'
                    required
                    placeholder='First Name'
                    className='bg-white border border-slate-300 rounded-md py-2 px-4 pr-2 focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1'
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </label>
              </div>
              <div className='p-1'>
                <label htmlFor='username'>Lastname :<br />
                  <input
                    type='text'
                    required
                    placeholder='Last Name'
                    className='bg-white border border-slate-300 rounded-md py-2 px-4 pr-2 focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1'
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </label>
              </div>
              <div className='p-1'>
                <label htmlFor='username'>Password :<br />
                  <input
                    type='password'
                    required
                    placeholder='Last Name'
                    className='bg-white border border-slate-300 rounded-md py-2 px-4 pr-2 focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </label>
              </div>
              <div className='flex mt-4 space-x-3'>
                <button type='reset' className='border border-orange-500 px-4 py-2 rounded-lg text-orange-500 hover:text-red-700 hover:border-red-700'>Cancel</button>
                <button type='submit' className='bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-400'>Save changes</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Setting;
